(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.target.closest?.('[data-memys-cookie-preferences]')) {
      window.privacyBanner?.showPreferences();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
